var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "nav-tabs-wrapper nav-tabs-multiple coupled mb-1 card",
      staticStyle: { overflow: "visible !important" },
    },
    [
      _c(
        "li",
        {
          staticClass: "nav nav-tabs scroll-container",
          staticStyle: {
            "margin-left": "0.6rem !important",
            "margin-right": "0.6rem !important",
          },
        },
        _vm._l(_vm.menu, function (ref) {
          var menuPage = ref.page
          var menuSections = ref.sections
          return _c(
            "ul",
            {
              key: menuPage.key,
              staticClass: "nav-item secondary",
              class: { "text-secondary bold": _vm.page === menuPage.key },
              attrs: { id: menuPage.key },
              on: {
                mouseover: function ($event) {
                  return _vm.handleHover(menuPage.key)
                },
                mouseleave: _vm.handleLeave,
                click: function ($event) {
                  return _vm.handlePageChange(menuPage.key)
                },
              },
            },
            [
              _c(
                "a",
                { staticClass: "nav-link grey-text text-darken-3 clickable" },
                [_vm._v("\n        " + _vm._s(menuPage.label) + "\n      ")]
              ),
              _vm._v(" "),
              _vm.arrayLength(menuSections, 1)
                ? _c(
                    "li",
                    {
                      ref: menuPage.key,
                      refInFor: true,
                      staticClass: "dropdown-menu",
                      staticStyle: { left: "unset" },
                      attrs: { "aria-labelledby": menuPage.key },
                    },
                    _vm._l(menuSections, function (section) {
                      return _c(
                        "ul",
                        {
                          key: section.key,
                          staticClass:
                            "menu-item my-2 dropdown force-relative font-weight-normal",
                          class: {
                            "dropdown-submenu":
                              _vm.arrayLength(section.sections, 1) ||
                              _vm.arrayLength(section.groups, 1),
                          },
                          attrs: { id: section.key },
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "clickable",
                              class: {
                                "dropdown-toggle":
                                  _vm.arrayLength(section.sections, 1) ||
                                  _vm.arrayLength(section.groups, 1),
                              },
                              attrs: {
                                "data-toggle":
                                  _vm.arrayLength(section.sections, 1) ||
                                  _vm.arrayLength(section.groups, 1)
                                    ? "dropdown"
                                    : null,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleSectionNavigation(
                                    menuPage.key,
                                    section.key
                                  )
                                },
                              },
                            },
                            [_vm._v(_vm._s(section.label))]
                          ),
                          _vm._v(" "),
                          _vm.arrayLength(section.sections, 1)
                            ? _c(
                                "li",
                                {
                                  staticClass: "dropdown-menu",
                                  attrs: {
                                    "data-display": "static",
                                    "aria-labelledby": section.key,
                                  },
                                },
                                _vm._l(section.sections, function (subSection) {
                                  return _c(
                                    "ul",
                                    {
                                      key: section.key + "-" + subSection.key,
                                      staticClass:
                                        "dropdown-submenu my-2 menu-item clickable",
                                      attrs: {
                                        id: section.key + "-" + subSection.key,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleSectionNavigation(
                                            menuPage.key,
                                            section.key,
                                            subSection.key
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "clickable",
                                          class: {
                                            "dropdown-toggle": _vm.arrayLength(
                                              subSection.groups,
                                              1
                                            ),
                                          },
                                          attrs: {
                                            "data-toggle": _vm.arrayLength(
                                              subSection.groups,
                                              1
                                            )
                                              ? "dropdown"
                                              : null,
                                          },
                                        },
                                        [_vm._v(_vm._s(subSection.label))]
                                      ),
                                      _vm._v(" "),
                                      _vm.arrayLength(subSection.groups, 1)
                                        ? _c(
                                            "li",
                                            {
                                              staticClass:
                                                "dropdown-menu dropdown-submenu position-absolute",
                                              attrs: {
                                                "data-display": "static",
                                                "aria-labelledby":
                                                  section.key +
                                                  "-" +
                                                  subSection.key,
                                              },
                                            },
                                            _vm._l(
                                              subSection.groups,
                                              function (group) {
                                                return _c(
                                                  "a",
                                                  {
                                                    key: group.key,
                                                    staticClass:
                                                      "dropdown-item my-2 menu-item clickable",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleSectionNavigation(
                                                          menuPage.key,
                                                          section.key,
                                                          group.key
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(group.label) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                }),
                                0
                              )
                            : _vm.arrayLength(section.groups, 1)
                            ? _c(
                                "li",
                                {
                                  staticClass: "dropdown-menu",
                                  attrs: {
                                    "data-display": "static",
                                    "aria-labelledby": "" + section.key,
                                  },
                                },
                                [
                                  _c(
                                    "ul",
                                    { staticClass: "dropdown-submenu pl-0" },
                                    _vm._l(section.groups, function (group) {
                                      return _c(
                                        "a",
                                        {
                                          key: group.key,
                                          staticClass:
                                            "dropdown-item my-2 menu-item clickable",
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleSectionNavigation(
                                                menuPage.key,
                                                group.key
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(group.label) +
                                              "\n              "
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }